import { render, staticRenderFns } from "./general_subcat_content.vue?vue&type=template&id=0d8fecdf&scoped=true&"
import script from "./general_subcat_content.vue?vue&type=script&lang=js&"
export * from "./general_subcat_content.vue?vue&type=script&lang=js&"
import style0 from "./general_subcat_content.vue?vue&type=style&index=0&id=0d8fecdf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8fecdf",
  null
  
)

export default component.exports